module.exports = __webpack_public_path__ + "img/bg3.7b0065a8.jpg";